import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDpd = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "#DC0032"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.00 7.34 L22.81 11.25 L16.00 15.16 L9.19 11.25 Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.90 11.76 L15.70 15.67 L15.70 23.49 L8.90 19.58 Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.30 15.67 L23.10 11.76 L23.10 19.58 L16.30 23.49 Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3 13.1 L16 10.9 L19.7 13.1 L19.7 12.1 L16 9.9 L12.3 12.1 Z",
			fill: "#DC0032"
		})
	]
});
export default SvgDpd;
